define('app-blazy/settings',[],function () {
    return {
        container: '.b-lazy, .b-lazy-div',
    };
});
